module.exports = __webpack_public_path__ + "static/media/combined.6df1b390.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resources/svg/combined.svg
// module id = 483
// module chunks = 0